import React from 'react';

type Props = {
  title: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  eyebrow?: string;
  className?: string;
};

export default function FeatureCard({ title, children, icon, eyebrow, className = '' }: Props) {
  return (
    <article className={`relative overflow-hidden rounded-[30px] border border-[var(--line-soft)] bg-[linear-gradient(180deg,rgba(255,255,255,0.98),rgba(244,247,251,0.92))] p-6 shadow-[0_20px_55px_-40px_rgba(7,26,49,0.34)] transition-all duration-300 hover:-translate-y-1 hover:border-[var(--brand-accent)]/40 hover:shadow-[0_34px_70px_-38px_rgba(15,39,68,0.24)] ${className}`}>
      <div className="absolute right-4 top-4 rounded-full border border-[var(--line-soft)] bg-white/90 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-[var(--text-muted)]">
        Service
      </div>
      <div className="flex h-14 w-14 items-center justify-center rounded-[20px] bg-[var(--surface-3)] text-2xl text-[var(--brand-accent)]">
        {icon}
      </div>
      {eyebrow && <p className="mt-5 text-xs font-semibold uppercase tracking-[0.24em] text-[var(--brand-accent)]">{eyebrow}</p>}
      <h4 className="mt-3 text-xl font-bold tracking-tight text-[var(--brand-ink)]">{title}</h4>
      <p className="mt-3 text-sm leading-7 text-[var(--text-muted)]">{children}</p>
      <div className="mt-6 h-px w-full bg-gradient-to-r from-[var(--brand-accent-soft)] to-transparent" />
    </article>
  );
}
